// extracted by mini-css-extract-plugin
module.exports = {"cardContainer":"GalleryImagesBox_cardContainer__pW2UV","cardBox":"GalleryImagesBox_cardBox__GYN0P","containerImageClass":"GalleryImagesBox_containerImageClass__61rbV"};